import { Observable } from "rxjs";
import { CORE_API } from "app/core/constants";
import { API } from "../constant/api.const";
import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from "@angular/core";
import { InterstoreInterface } from "./interstore.interface";
import { HTTP_SERVICE, HttpInterface } from "app/core/services";
import { BaseResponseModel, SelectListItem } from "app/core/models";
import { InterstoreProductRequestDataModel, InterstoreSearchModel, InterstoreSearchProductDataModel, LadgerDataListModel, ProductInventoryDataModel } from "../model";
@Injectable()

export class InterstoreService implements InterstoreInterface {

  constructor(
    @Inject(HTTP_SERVICE) private _httpInterface: HttpInterface
  ) { }


  getStoreWiseMetaData(styleNo: string): Observable<BaseResponseModel<SelectListItem>> {
    const params = new HttpParams().set('styleNo', styleNo);
    return this._httpInterface.get(API.GET_STORE_WISE_META_DATA, params);
  }

  searchProductInInventory(searchModel: InterstoreSearchModel): Observable<BaseResponseModel<ProductInventoryDataModel>> {
    return this._httpInterface.post<BaseResponseModel<ProductInventoryDataModel>>(API.SEARCH_PRODUCT_INVENTORY, searchModel);
  }

  searchProductInterStore(searchModel: InterstoreSearchModel): Observable<BaseResponseModel<InterstoreSearchProductDataModel>> {
    return this._httpInterface.post<BaseResponseModel<InterstoreSearchProductDataModel>>(API.SEARCH_PRODUCT_INTERSTORE, searchModel);
  }

  mackToOrderDesing(productHeaderIds: Array<number>): Observable<BaseResponseModel<string>> {
    return this._httpInterface.post<BaseResponseModel<string>>(API.REQUEST_INTERSTORE_TRANSFER, { productHeaderIds });
  }

  getLadgerDataList(): Observable<BaseResponseModel<LadgerDataListModel>> {
    return this._httpInterface.get(API.GET_LADGER_DATA);
  }

  downloadLedgerInvoice(ledgerId: number): Observable<BaseResponseModel<LadgerDataListModel>> {
    const params = new HttpParams().set('storeLedgerId', String(ledgerId));
    return this._httpInterface.get(API.GET_LEDGER_INVOICE_BY_ID, params);
  }

  getProductRequestRecevedList(params?: HttpParams): Observable<BaseResponseModel<InterstoreProductRequestDataModel>> {
    return this._httpInterface.get<BaseResponseModel<InterstoreProductRequestDataModel>>(API.GET_PRODUCT_REQUEST_RECEVED_LIST, params);
  }

  getProductRequestItemsByRequestId(requestId: number): Observable<BaseResponseModel<InterstoreProductRequestDataModel>> {
    const params = new HttpParams().set('id', String(requestId));
    return this._httpInterface.get<BaseResponseModel<InterstoreProductRequestDataModel>>(API.GET_PRODUCT_REQUEST_ITEMS_BY_REQUEST_ID, params);
  }

  productShipmentStatusById(productId: number): Observable<BaseResponseModel<InterstoreProductRequestDataModel>> {
    return this._httpInterface.post<BaseResponseModel<InterstoreProductRequestDataModel>>(API.STORE_SHIPMENTS_STATUS, { id: productId });
  }

  updateInterstoreTransferRequestStatus(payload: any): Observable<BaseResponseModel<string>> {
    return this._httpInterface.post<BaseResponseModel<string>>(API.UPDATE_INTERSTORE_TRANSFER_REQUEST_STATUS, payload);
  }

  getInterStoreInvoiceByRequestId(invoiceId: number): Observable<BaseResponseModel<string>> {
    const params = new HttpParams().set('id', String(invoiceId));
    return this._httpInterface.get<BaseResponseModel<string>>(API.GET_INTERSTORE_INVOICE_BY_REQUEST_ID, params);
  }

  updateInterstoreTransferRequestReceivedStatus(productId: number): Observable<BaseResponseModel<string>> {
    return this._httpInterface.post<BaseResponseModel<string>>(API.UPDATE_INTERSTORE_TRANSFER_REQUEST_RECEIVED_STATUS, { id: productId });
  }

  updateInterstoreTransferRequestPaymentStatus(productId: number): Observable<BaseResponseModel<string>> {
    return this._httpInterface.post<BaseResponseModel<string>>(API.UPDATE_INTERSTORE_TRANSFER_REQUEST_PAYMENT_STATUS, { id: productId });
  }

  uploadDocument(formData: FormData): Observable<BaseResponseModel<string>> {
    return this._httpInterface.post<BaseResponseModel<string>>(API.UPLOAD_DOCUMENT, formData);
  }

  getDocumentDetailsByRequestId(requestId: number): Observable<BaseResponseModel<any>> {
    const params = new HttpParams().set('id', String(requestId));
    return this._httpInterface.get<BaseResponseModel<any>>(API.GET_DOCUMENT_DETAILS, params);
  }
}
